// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8d391be2","703":"d7518f35","787":"817ef587"}[chunkId] + ".chunk.js";
};